// src/CONTAINERCONTROL/equipmentCostRuleList.jsx
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const EquipmentCostRuleList = ({ roles }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit' || operation === 'Copy') {
            if (row) {
                sessionStorage.setItem('editingEquipmentCostRule', JSON.stringify(row))
                sessionStorage.setItem('operationType', operation)
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    return (
        <M_Table
            entityName={'EquipmentCostRule'}
            api='secondary'
            showTitle={true}
            title={'Equipment Cost Rules'}
            roleName={'usersGroups'}
            rolePermissions={roles}
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('containerControl/equipmentCostRuleCrud', 'Create', t('Add') + ' ' + t('EquipmentCostRule'), row)],
                ['Edit',   (row) => newRoute('containerControl/equipmentCostRuleCrud', 'Edit',   t('Edit') + ' ' + t('EquipmentCostRule'), row)],
                ['Copy',   (row) => newRoute('containerControl/equipmentCostRuleCrud', 'Copy',   t('Copy') + ' ' + t('EquipmentCostRule'), row)],
            ])}
        />
    )
}